import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { t } from '../i18n';
import { cardSvg } from '../cardDesigns';

const C = { ink: '#2C2C2A', muted: '#5F5E5A', primary: '#0F6E56' };

// Ye safha KHULA hai — koi login nahi.
// WhatsApp/email ka link yahin aata hai, is liye ajnabi bhi khol sakta hai.
export default function CardView() {
  const { token } = useParams();
  const [card, setCard] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    fetch(`/api/reminders/cards/view/${token}/`)
      .then(async (r) => {
        const d = await r.json();
        if (!r.ok) throw new Error(d.error || 'Not found');
        setCard(d);
      })
      .catch((e) => setErr(e.message));
  }, [token]);

  if (err) {
    return (
      <div style={{ padding: '3rem 1.5rem', textAlign: 'center' }}>
        <p style={{ fontSize: 15, color: C.muted }}>{err}</p>
        <Link to="/" style={{ fontSize: 13, color: C.primary }}>{t('card_go_home')}</Link>
      </div>
    );
  }
  if (!card) return <div style={{ padding: '3rem', textAlign: 'center', color: C.muted }}>…</div>;

  const svg = cardSvg(card.design, card.bg_color, card.occasion_label.replace(/^\S+\s/, ''), card.to ? `${t('card_for')} ${card.to}` : '');

  return (
    <div style={{ padding: '1.5rem 1.25rem 3rem', maxWidth: 420, margin: '0 auto', textAlign: 'center' }}>
      <div style={{ marginBottom: 18 }} dangerouslySetInnerHTML={{ __html: svg }} />

      {card.message && (
        <div style={{ background: '#fff', border: '0.5px solid #E3E1D9', borderRadius: 12, padding: '18px 20px', marginBottom: 14 }}>
          <p style={{ fontSize: 15, lineHeight: 1.65, color: C.ink, margin: 0, whiteSpace: 'pre-wrap' }}>{card.message}</p>
        </div>
      )}

      <p style={{ fontSize: 13.5, color: C.muted, margin: '0 0 4px' }}>
        — {t('card_from')} <Link to={`/profile/${card.from_username}`} style={{ color: C.primary, fontWeight: 600, textDecoration: 'none' }}>{card.from}</Link>
      </p>
      <p style={{ fontSize: 11, color: C.muted, margin: '0 0 24px' }}>{card.sent_at}</p>

      <div style={{ borderTop: '0.5px solid #E3E1D9', paddingTop: 18 }}>
        <p style={{ fontSize: 12.5, color: C.muted, margin: '0 0 10px', lineHeight: 1.55 }}>{t('card_footer_note')}</p>
        <Link to="/card/new" style={{
          display: 'inline-block', fontSize: 13.5, padding: '9px 18px', borderRadius: 8,
          background: C.primary, color: '#fff', textDecoration: 'none', fontWeight: 600,
        }}>💌 {t('card_send_one_back')}</Link>
      </div>
    </div>
  );
}
